(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    

$('.flex-footer__item--menuNew .flex-footer__item--menu h4').click(function(evt){
  evt.preventDefault();
  var startHeight = $('footer').outerHeight();
  $('.flex-footer__item--menuNew .site-footer__linklist').removeClass('opened');
  $(this).parent('.flex-footer__item--menu').find('.site-footer__linklist').addClass('opened');
  var finalHeight = $('footer').outerHeight();
  $('main#MainContent').css("margin-bottom", finalHeight);
  if(finalHeight > startHeight){
    $('html, body').animate({scrollTop: $('html, body').scrollTop() + (finalHeight - startHeight)}, 1000);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const $dropdown = $(".navigation__has-sublinks");
const $dropdownToggle = $(".navigation__expand-sublinks");
const $dropdownMenu = $(".navigation__sublinks-container");
const showClass = "navigation__has-sublinks--collapsed";

$(window).on("load resize", function() {
  if (this.matchMedia("(min-width: 768px)").matches) {
    $dropdown.hover(
      function() {
        const $this = $(this);
        $this.removeClass(showClass);                
        $this.find($dropdownToggle).attr("aria-expanded", "true");
      },
      function() {
        const $this = $(this);
        $this.addClass(showClass);        
        $this.find($dropdownToggle).attr("aria-expanded", "false");
      }
    );
  } else {
    $dropdown.off("mouseenter mouseleave");
  }
});

  } catch(e) { console.error(e); }
})();

})();
